export function addWatermarkToPdf(doc: any) {
  const pageCount = doc.internal.getNumberOfPages();
  const pageWidth = doc.internal.pageSize.width;
  const pageHeight = doc.internal.pageSize.height;

  for (let i = 1; i <= pageCount; i++) {
    doc.setPage(i);
    doc.saveGraphicsState();
    
    // Set opacity to 13% as requested
    try {
      const gState = new (doc as any).GState({ opacity: 0.13 });
      doc.setGState(gState);
    } catch (e) {
      doc.setTextColor(220, 220, 220);
    }

    doc.setFontSize(80);
    doc.setFont("helvetica", "bold");
    doc.setTextColor(0, 0, 0); // Black text, opacity will make it watermark-like
    
    const centerX = pageWidth / 2;
    const centerY = pageHeight / 2;
    
    const angleDeg = 35; // Bottom-left to top-right
    const angleRad = angleDeg * Math.PI / 180;
    const cosA = Math.cos(angleRad);
    const sinA = Math.sin(angleRad);
    
    const textStr = "BR TEACHER";
    const textWidth = doc.getTextWidth(textStr);
    const logoSize = 70; 
    const gap = 15;
    const totalWidth = logoSize + gap + textWidth;
    
    // Local coordinates (X axis is along the text baseline, Y axis points down)
    const logoLocalX = -totalWidth / 2;
    const logoLocalY = -logoSize + 12; // Adjust to align vertically with text
    
    const textLocalX = -totalWidth / 2 + logoSize + gap;
    const textLocalY = 0;
    
    // Global coordinates
    const logoGlobalX = centerX + logoLocalX * cosA + logoLocalY * sinA;
    const logoGlobalY = centerY - logoLocalX * sinA + logoLocalY * cosA;
    
    const textGlobalX = centerX + textLocalX * cosA + textLocalY * sinA;
    const textGlobalY = centerY - textLocalX * sinA + textLocalY * cosA;
    
    // Logo Data URL (SVG from index.html)
    const logoData = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0naHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmcnIHZpZXdCb3g9JzAgMCAxMDAgMTAwJz48Y2lyY2xlIGN4PSc1MCcgY3k9JzUwJyByPSc0OCcgZmlsbD0nd2hpdGUnIHN0cm9rZT0nI2VhNTgwYycgc3Ryb2tlLXdpZHRoPSc0Jy8+PHBhdGggZD0nTTUwIDIwTDgwIDM1TDUwIDUwTDIwIDM1TDUwIDIwWicgZmlsbD0nIzFlMjkzYicvPjxwYXRoIGQ9J00zNSA0MlY1MEMzNSA1MCA0MCA1NSA1MCA1NUM2MCA1NSA2NSA1MCA2NSA1MFY0Micgc3Ryb2tlPScjMWUyOTNiJyBzdHJva2Utd2lkdGg9JzMnLz48dGV4dCB4PSc1MCcgeT0nODUnIHRleHQtYW5jaG9yPSdtaWRkbGUnIGZpbGw9JyMxZTI5M2InIHN0eWxlPSdmb250LXNpemU6IDE4cHg7IGZvbnQtd2VpZ2h0OiA5MDA7IGZvbnQtZmFtaWx5OiBzYW5zLXNlcmlmOyc+QlI8L3RleHQ+PC9zdmc+";
    
    try {
      doc.addImage(logoData, 'SVG', logoGlobalX, logoGlobalY, logoSize, logoSize, undefined, 'FAST', angleDeg);
    } catch (e) {
      // Skip logo if error
    }

    doc.text(textStr, textGlobalX, textGlobalY, {
      angle: angleDeg
    });
    
    doc.restoreGraphicsState();
  }
}
